<template>
    <div>
        <v-app class="p-4">
            <template>
                <v-row justify="center">
                    <v-dialog v-model="relatedModal" max-width="1080" transition="dialog-bottom-transition">
                        <v-card class="pb-5">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>ویرایش</v-toolbar-title>

                                <v-spacer></v-spacer>

                                <v-toolbar-items>
                                    <v-btn icon dark @click="relatedModal = false">
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </v-toolbar-items>
                            </v-toolbar>

                            <v-content class="pt-10">
                                <related-advertise v-if="relatedModal" :related_id="related_id"></related-advertise>
                            </v-content>

                        </v-card>
                    </v-dialog>
                </v-row>
            </template>


            <div class="col-md-12 p-0 mt-5 pt-10 mx-auto" style="border: none!important;">

                <div class="mt-5 mt-5">
                    <router-link to="/Monitoring/NewestInDivar/add">
                        <v-btn class="btn-add-with-text">
                            <span class="fa fa-plus ml-1"></span>
                            افزودن تازه های دیوار
                        </v-btn>
                    </router-link>
                </div>
                <v-card :loading="loading" class="p-3 pt-0">

                    <terminal-table :currentPage="datas.current_page"
                                    :perPage="datas.per_page" v-if="isMobile" :getData="getDataForTable"
                                    :pageCount="datas.last_page"
                                    :options="tableProps" :datas="datas" :headers="columns"></terminal-table>

                    <data-table
                            v-else
                            :data="datas"
                            :columns="columns"
                            :debounce-delay="3000"
                            :pagination="paginate"
                            :orderBy="tableProps.column"
                            :orderDir="tableProps.dir"
                            :translate="translate"
                            :per-page="[10, 25, 50, 100, 500]"
                            @on-table-props-changed="reloadTable"
                            class="pt-5 mt-5 table-striped text-center table-hover table-responsive-lg table-responsive-md table-responsive-sm table-responsive-xs"
                    ></data-table>
                </v-card>
            </div>
        </v-app>
    </div>
</template>

<script>
import SimilarAds from "@/view/pages/ads/similarAds/similarAds";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import {dataTableProps} from "@/main";
import {debounce} from "../../../../custom";
import button from "../../button";
import RelatedAdvertise from "./relatedAdvertise";


export default {
    name: "NewestDivar",
    components: {RelatedAdvertise, TitleRibbon, SimilarAds},
    data() {
        return {
            tarafeName: "",
            authModal: false,
            loading: false,
            adsModal: false,
            relatedModal: false,
            related_id: null,
            datas: {},
            mine: [],
            translate: dataTableProps.translate,
            tableProps: dataTableProps.tableProps,
            paginate: dataTableProps.pagination,
            url: `${url}/smarts?type=news`,
            selectedNumber: [],
            dataId: '',
            adsList: '',
            columns: [
                {
                    label: '<input type="checkbox" id="selectAll">',
                    isCheckBox:true,
                    transform: (val) => {
                        return `<input type="checkbox"  data-id="${val.data.phone}">`
                    },
                    orderable: false,
                },
                {
                    label: 'ردیف',
                    transform: (val) => {
                        let row = this.datas.current_page - 1;
                        row = row * this.datas.per_page;
                        return row + val.row + 1;
                    },
                    orderable: true,
                },
                {
                    label: 'شناسه',
                    name: 'id',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'نام مستعار',
                    name: 'nick_name',
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'کلمه کلیدی',
                    name: 'search_payload.key_word',
                    transform: (val) => {
                        return val.data.search_payload.key_word ? val.data.search_payload.key_word : '-';
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'شهر و محله',
                    name: 'search_payload.cities',
                    transform: (val) => {
                        return this.translator("city_" + val.data.search_payload.cities);
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'نام دسته',
                    name: 'search_payload.category',
                    primary:true,
                    transform: (val) => {
                        return this.translator(val.data.search_payload.category);
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'زمان ایجاد',
                    name: 'last_activity',
                    transform: (val) => {
                        return val.data.last_activity ? val.data.last_activity : '-'
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'آخرین فعالیت',
                    name: 'last_activity_',
                    transform: (val) => {
                        return val.data.last_activity ? val.data.last_activity : '-'
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'تعداد ارسال شده',
                    name: 'assessed',
                    transform: (val) => {
                        return val.data.assessed ? val.data.assessed : '0'
                    },
                    orderable: true,
                    searchable: true,
                },
                {
                    label: 'مدیریت',
                    name: 'action',
                    component: button,
                    event: "actions",
                    meta: {
                        buttons: [
                            {
                                name: 'delete',
                                label: 'حذف',
                                icon: 'trash-alt',
                                class: 'btn-outline-danger',
                                action: this.actions,
                            },
                            {
                                name: 'related',
                                label: 'آگهی های مرتبط',
                                icon: 'list',
                                class: 'btn-outline-primary',
                                action: this.actions,
                            },
                        ]
                    }
                },
            ],
            updatedData: [],
            authResult: [],
        }
    },
    methods: {
        translator(name) {
            return this.translates[name];
        },
        getDataForTable(url = this.url, query = this.tableProps) {
            const vm = this;
            vm.loading = true;
            $.ajax({
                url: url,
                type: 'GET',
                fn: this.getDataForTable,
                data: query,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: function (data) {
                    vm.datas = data;
                    vm.loading = false;
                }
            })
        },
        reloadTable(tableProps) {
            debounce(() => {
                this.getDataForTable(this.url, tableProps);
            }, 700);
        },
        actions(data, type) {
            this[type + "Action"](data);
        },
        deleteAction(data) {
            this.$modal.yesNo('تایید حذف', 'آیا از حذف این دسته اطمینان دارید؟', "neg", '').then((value => {
                if (value === true) {
                    $.ajax({
                        url: `${url}/smarts/${data.id}`,
                        method: 'DELETE',
                        msg: true,
                        fn: this.deleteAction,
                        headers: {
                            "ACCEPT": "application/json",
                            "Authorization": Token
                        },
                        success: (val) => {
                            this.reloadTable();
                        },
                    });
                }
            }));
        },
        relatedAction(data) {
            this.related_id = data.id;
            this.relatedModal = true;
        },
        allowOnlyNumbers(value) {
            if (typeof Number(value.key) !== 'string') {
                let allowedKeys = [8, 46, 38, 40, 37, 39];
                const keypressed = value.which || value.keyCode;
                if (/[^0-9\s]+/.test(value.key)) {
                    if (allowedKeys.every(e => e !== keypressed)) {
                        value.preventDefault();
                    }
                } else return true
            }
        },
        getLocalization() {
            if (localStorage.getItem('localization')) {
                this.translates = JSON.parse(localStorage.getItem('localization'));
                return;
            }
            $.ajax({
                url: `${url}/setting/localization`,
                type: 'GET',
                fn: this.getLocalization,
                headers: {
                    "ACCEPT": "application/json",
                    "Authorization": Token
                },
                success: (data) => {
                    this.translates = data
                    localStorage.setItem('localization', JSON.stringify(data));
                }
            })
        },
    },
    computed:{
        isMobile() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    this.getDataForTable(this.url);
                    return true
                case 'sm':
                    this.getDataForTable(this.url);
                    return true
                case 'md':
                    this.getDataForTable(this.url);
                    return false
                case 'lg':
                    this.getDataForTable(this.url);
                    return false
                case 'xl':
                    this.getDataForTable(this.url);
                    return false
            }
        },
    },
    mounted() {
        this.getDataForTable(this.url);
        this.getLocalization();
        $(document).on('click', '#selectAll', (element) => {
            if ($(element.target).is(':checked')) {
                $('input[type="checkbox"]').prop('checked', true);

                const selected = $('input[type="checkbox"]').map(function () {
                    return $(this).data('id')
                }).get();

                this.selectedNumber = selected;
            } else {
                $('input[type="checkbox"]').prop('checked', false)
                this.selectedNumber = []
            }
        });
    },
}
</script>

<style scoped>

</style>